export default __webpack_public_path__ + "static/media/Auditor Logo.4ecc5eb8.png";